(function() {
    'use strict';
    /**
     * @memberof app
     *@ngdoc service
     *@name DatosService
     *@description
     *Servicio de autores
     */

    angular
        .module('app')
        .factory('DatosService', DatosService);

    DatosService.$inject = ["$http","$window","$location"];

    function DatosService($http,$window,$location){  

        var sesion = {
            getResult:getResult,
            getPost:getPost,
        };

        function getResult(vm)  {
            
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            };
            
            return $http.get('/ajax/getlista?category='+vm.category+'&category_disease='+vm.category_disease+'&category_allergie='+vm.category_allergie+'&lang_id='+vm.lang_id, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                return data.data;
            }
            function getContentFailed(data){
                
                return false;
            }
        }

        function getPost(filtros,vm)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }
           
            return $http.get('/ajax/getpost', { params : { filtros : JSON.stringify(filtros),lang_id:lang_id,page:vm.page}  }, config)
            .then(function(data){
                return data.data;
            },function(data){
                return data;
            });


        }

      return sesion;
    }
})();

